/**
 * Must match `RESTAURANT_HERO_IMAGE_UPLOAD_CONTENT_TYPES` in
 * `api/src/restaurants/restaurantHeroImageUploadConstants.ts`.
 * If the web list is wider than the API, upload-url requests fail validation;
 * if narrower, guests cannot upload formats the API already accepts.
 */
export const RESTAURANT_HERO_IMAGE_UPLOAD_CONTENT_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
] as const;

export const getRestaurantHeroImageUploadContentType = (file: File): string => {
  if (
    file.type &&
    (RESTAURANT_HERO_IMAGE_UPLOAD_CONTENT_TYPES as readonly string[]).includes(
      file.type,
    )
  ) {
    return file.type;
  }
  throw new Error(
    'Unsupported image type. Please use a JPEG, PNG, WebP, or GIF file.',
  );
};
